<template>
  <v-autocomplete
    v-model="selectedPatient"
    :items="patientList"
    filled
    :placeholder="placeholder ? placeholder : $ucfirst($t('patient.search'))"
    prepend-inner-icon="mdi-magnify"
    flat
    solo
    item-value="patientId"
    return-object
    :search-input.sync="searchInput"
    clearable
    hide-details
    hide-no-data
    no-filter
    :disabled="disabled"
    :style="{ opacity: disabled ? 0.5 : 1 }"
  ></v-autocomplete>
</template>

<script>
import { debounce } from 'debounce';
import moment from 'moment';

/**
 * Component PatientSearch.vue
 *
 * @module PatientSearch
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Patient/PatientSearch.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientSearch',
  props: {
    value: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      searchInput: '',
      debouncedSearch: null,
      patientList: [],
    };
  },
  computed: {
    selectedPatient: {
      get() {
        return this.value;
      },
      set(patient) {
        this.$emit('input', patient);
      },
    },
  },
  watch: {
    searchInput(value) {
      if (value) {
        this.debouncedSearch();
      } else  {
        this.patientList = [];
      }
    },
    value(value) {
      this.setMinimalItemList(value);
    },
  },
  methods: {
    async search() {
      const currentSelection = this.patientList
        .find((item) => item.text === this.searchInput)

      if (currentSelection) {
        this.patientList = [currentSelection];
      } else {
        const edges = await this.$store
          .dispatch('patientList/search', this.searchInput);

        if (!edges) return;

        this.patientList = edges.map(({ node }) => {
          const birthDate = moment(node.patient.birthdate).format('YYYY');

          return {
            text: `${node.subjectId} (${birthDate})`,
            patientId: node.patient.patientId.toString(),
          }
        });
      }
    },
    setMinimalItemList(value) {
      if (!value || !value.patientId) return;

      const minimalList = this.patientList
        .find((item) => item.text === this.value.text)

      if (!minimalList) {
        this.patientList = [value];
      }
    }
  },
  created() {
    this.debouncedSearch = debounce(this.search, 500);

    if (this.value) {
      this.setMinimalItemList(this.value);
    }
  },
};
</script>
